import { drawing as d } from '@progress/kendo-drawing';
import { Rectangle } from './Rectangle';
/**
 * @hidden
 *
 * A base class for shapes that require multiple path elements for rendering.
 * Extends Rectangle and provides functionality for complex shapes with multiple drawing paths.
 */
export class MultiPathShape extends Rectangle {
    /** @hidden */
    _initPath() {
        const options = this.options;
        this.drawingElement = new d.MultiPath({
            stroke: options.stroke,
            id: options.id
        });
        this._fill();
        this._drawPath();
    }
}
